export const STATUS_IN_PROGRESS = 'in_progress';
export const COMPLETE = 'complete';
export const FAILED = 'failed';
export const BACKUP_HAS_PENDING_MIGRATIONS = 'backup_has_pending_migrations';
